
import Routes from './Routes'
import React,{useEffect,useState} from 'react'
import './App.css'
import Header from './components/Header'
import Footer from './components/Footer'
import LeftSideNav from './components/LeftSideNav'
import { Helmet } from 'react-helmet-async';
import { useLocation,useHistory } from "react-router-dom";
import IdleTimer from 'react-idle-timer'
import utils from './utils'
import {REFRESH_ACCESS_TOKEN_TIME_MS,GLOBAL_TIME_MINS,LOGOUT_TIME_MINS,COUNT_DOWN_SECS,CURRENT_HOST} from './constants'
import { Dialog } from 'primereact/dialog';
import {Button} from 'primereact/button'
import moment from 'moment';
var timer;
var countdowntimer;
function App() {
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [showDialog,setShowDialog] = useState(false)
  const authlist = [
    'my-profile',
    'change-password',
    'multi-factor-auth',
    'security-question',
    'verify-phone',
    'phone-success',
    'verify-email',
    'email-success',
    'email-update-success',
    'faqsauth'
  ]

  const unauthlist = [
    'activate-account',
    'password-reset',
    'faqs'
  ]

  const unsetContinueCookie = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "c" + "=" +"false"  + "; path=/; secure; domain=" + CURRENT_HOST;

  }

  const setContinueCookie = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "c" + "=" +"true"  + "; path=/; secure; domain=" + CURRENT_HOST;

  }

  const unsetCountdownCookie = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "d" + "=" +"false"  + "; path=/; secure; domain=" + CURRENT_HOST;
  }

  const setCountdownCookie = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "d" + "=" +"true"  + "; path=/; secure; domain=" + CURRENT_HOST;
  }

  const setCookie = ()=>{
    if (document.cookie?.split(';')?.find(x => x.includes('last_active_time'))?.length > 0) {
      var date = new Date();
      var activeTime = date.toGMTString();
      var expireDate = new Date();
      expireDate.setTime(date.getTime() + (3 * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + expireDate.toGMTString();
      document.cookie = "last_active_time" + "=" + activeTime  + "; path=/; secure; domain=" + CURRENT_HOST;
    }
  }

  const setGlobalTimer = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (GLOBAL_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "st" + "=" + date.toGMTString()  + "; path=/; secure; domain=" + CURRENT_HOST;
    if(timer){
      console.log("clear timer")
      clearInterval(timer)
    }
    timer = setInterval(function(){

      console.log("check the cookie if exist")
      var checkcookie = document.cookie;
      if(checkcookie.indexOf("f=true")>-1){
        //window.location.replace(`${window.location.origin}/accountmanagement/login.html`)

        setTimeout(function(){
          fetch(`${process.env.PUBLIC_URL}mfa/webapi/invalidlogout`).then(res=>res.text()).then(result=>console.log(result))
        },100)
        setTimeout(()=>{
          window.location.replace(`${process.env.PUBLIC_URL}/webapi/logout`)
        },500)
     
      }

      if (checkcookie.indexOf("st=") > -1&&!(window.location.href.indexOf("unauth") > -1)) {
        var stCookie = document.cookie?.split(';')?.find(x => x.includes('st='))?.split('=')[1]
        if(moment().utc().isAfter(moment(stCookie))){
          setShowDialog(true)
        }
      }
      
      // if(checkcookie.indexOf("st=")==-1){
      //   setShowDialog(true)
      // }

      if(checkcookie.indexOf("c=true")>-1){
        setShowDialog(false)
        setTimeout(()=>{
          unsetContinueCookie()
        },1000)
      }

      if(checkcookie.indexOf("d=true")>-1){
        if(countdowntimer){
          clearTimeout(countdowntimer)
        }
      }
    },1000)
  }
  
  const handleOnAction = (event)=>{
    console.log('user did something', event)
    setGlobalTimer()
    setCountdownCookie()
    setCookie()
    if(countdowntimer){
      clearTimeout(countdowntimer)
    }
  }

  const handleOnActive = (event)=>{
    console.log('user is active', event)
    setGlobalTimer()
    setCountdownCookie()
    setCookie()
    if(countdowntimer){
      clearTimeout(countdowntimer)
    }
  }

  const handleOnIdle = (event)=>{
    console.log('logout', event)
    // if(window.location.href.indexOf('/auth')>-1){
    //   utils.logout()
    // }
  }

  const flagToLogout = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "f" + "=" + "true"  + "; path=/; secure; domain=" + CURRENT_HOST;
  }

  const unsetflagToLogout = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "f" + "=" + "false"  + "; path=/; secure; domain=" + CURRENT_HOST;
  }

  useEffect(()=>{
    unsetContinueCookie()
    unsetflagToLogout()
    unsetCountdownCookie()
    setGlobalTimer()

    if(!(window.location.href.indexOf("unauth") > -1)){
    if (document.cookie?.split(';')?.find(x => x.includes('last_active_time'))?.length > 0) {
      console.log('calculating')
      var lastActiveTime = document.cookie?.split(';')?.find(x => x.includes('last_active_time'))?.split('=')[1]
      var sinceLastActive = moment(lastActiveTime).diff(moment().utc(), 'minutes')
      console.log(lastActiveTime)
      console.log(sinceLastActive)
      if (Math.abs(sinceLastActive) > 2) {
        flagToLogout()
      } else {
        setCookie()
      }
    } else {
      console.log('no cookies found')
      flagToLogout()
    }
  }


    //initial call when the app load, to prevent the user load a different tab and access token expired.
    utils.refreshAccessToken()

    const timer = setInterval(()=>{
      utils.refreshAccessToken()
      console.log(`call refresh every ${REFRESH_ACCESS_TOKEN_TIME_MS} ms.`)
    }, REFRESH_ACCESS_TOKEN_TIME_MS)

    const unlisten = history.listen((location,action)=>{
      utils.refreshAccessToken()
    })

    return ()=>{
      clearInterval(timer)
      unlisten()
    }

  },[])
  const onHide = ()=>{
    setShowDialog(false)
  }
  const footer = (
    <div className="logout-dialog-buttons">
        <Button label="Continue" onClick={()=>{
          setContinueCookie()
          unsetflagToLogout()
          setGlobalTimer()
          unsetCountdownCookie()
          if(countdowntimer){
              clearTimeout(countdowntimer)
          }
          onHide()
        }} />
        <Button label="Logout" className="p-button-text" onClick={()=>{
          flagToLogout()
          onHide()
        }} />
    </div>
);

  return (
    <div className="layout-body">
      <Helmet>
        <title>Account Management</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>
      <Header />
      <IdleTimer
          timeout={1000 * 60 * 15} // change to highter number to increase the logout time
          onActive={handleOnActive}
          onIdle={handleOnIdle}
          onAction={handleOnAction}
          debounce={250}
        />
 
        <Dialog className="logout-dialog" footer={footer} visible={showDialog} modal onHide={onHide} onShow={()=>{

          countdowntimer = setTimeout(()=>{
            flagToLogout()
          },COUNT_DOWN_SECS)
          unsetCountdownCookie()
        }}>
            <div className="logout-dialog-title">You session is about to expire.</div>
            <div className="logout-dialog-content">For your security, this session will expire due to inactivity. If you want to extend your session, please select the 'Continue' button. If you select the 'Log Out' button or do not respond, your session will automatically close.</div>
        </Dialog>
 
      <div className={`${authlist.indexOf(splitLocation[2]) === -1 &&unauthlist.indexOf(splitLocation[2]) === -1 ? 'notfound-container' : ''}`}>
      <div className={`content ${splitLocation[1] === "" ? 'none' : ((authlist.indexOf(splitLocation[2]) > -1) ? 'authpage authpagecontent' : '')}`}>
        <div className="left-nav">
          <LeftSideNav />
        </div>
        <Routes />
      </div>
      <div className={`${splitLocation[1] === "" ? 'none' : ((authlist.indexOf(splitLocation[2]) > -1) ? 'authpage' : '')}`}>
        <Footer />
      </div>
      </div>
    </div>
  );
}

export default App;
